module.exports = __webpack_public_path__ + "static/media/MSS Logo-100.f6314f11.jpg";